bq.global.popoverSetup = function() {
  if (Modernizr.appleios) {
    $('[data-toggle="popover"]').each(function() {
      $(this)
        .popover({
          container: $(this).data('container') || false,
          placement: $(this).data('placement') || 'auto',
          trigger: 'click'
        })
        .on('shown.bs.popover', function() {
          var thiz = $(this);
          setTimeout(function() {
            thiz.popover('hide');
          }, 1000);
        });
    });
  } else {
    $('[data-toggle="popover"]').each(function() {
      $(this).popover({
        container: $(this).data('container') || false,
        placement: $(this).data('placement') || 'auto'
      })
      .on('shown.bs.popover', function () {
        var popoverBlock = $('body > div.popover');
        popoverBlock.attr('role', 'dialog');
        popoverBlock.attr('aria-label', 'Popup');
      })
    });
  }
};

bq.init.push(bq.global.popoverSetup);
